
import { useTranslation } from 'react-i18next';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

export default function TermsPage() {
  const { t } = useTranslation('terms');

  return (
    <div className="min-h-screen bg-white dark:bg-gray-900">
      <Navbar />
      
      <main className="pt-24 pb-16">
        <div className="max-w-4xl mx-auto px-6">
          <h1 className="text-4xl font-bold text-gray-900 dark:text-gray-100 mb-4">{t('title')}</h1>
          <p className="text-sm text-gray-600 dark:text-gray-400 mb-12">{t('lastUpdated')}</p>

          {/* Section 1 */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-4">{t('section1.title')}</h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">{t('section1.content1')}</p>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">{t('section1.content2')}</p>
          </section>

          {/* Section 2 */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-4">{t('section2.title')}</h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">{t('section2.intro')}</p>
            <ul className="space-y-3">
              {(t('section2.items', { returnObjects: true }) as string[]).map((item, index) => (
                <li key={index} className="text-gray-700 dark:text-gray-300 leading-relaxed">{item}</li>
              ))}
            </ul>
          </section>

          {/* Section 3 */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-4">{t('section3.title')}</h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">{t('section3.intro')}</p>
            <ul className="space-y-3">
              {(t('section3.items', { returnObjects: true }) as string[]).map((item, index) => (
                <li key={index} className="text-gray-700 dark:text-gray-300 leading-relaxed">{item}</li>
              ))}
            </ul>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed mt-4 font-medium">{t('section3.note')}</p>
          </section>

          {/* Section 4 */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-4">{t('section4.title')}</h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">{t('section4.intro')}</p>
            <ul className="space-y-3">
              {(t('section4.items', { returnObjects: true }) as string[]).map((item, index) => (
                <li key={index} className="text-gray-700 dark:text-gray-300 leading-relaxed">{item}</li>
              ))}
            </ul>
          </section>

          {/* Section 5 */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-4">{t('section5.title')}</h2>
            
            <div className="mb-6">
              <h3 className="text-xl font-bold text-gray-900 dark:text-gray-100 mb-3">{t('section5.sub1.title')}</h3>
              <p className="text-gray-700 dark:text-gray-300 leading-relaxed">{t('section5.sub1.content')}</p>
            </div>

            <div className="mb-6">
              <h3 className="text-xl font-bold text-gray-900 dark:text-gray-100 mb-3">{t('section5.sub2.title')}</h3>
              <p className="text-gray-700 dark:text-gray-300 leading-relaxed">{t('section5.sub2.content')}</p>
            </div>

            <div>
              <h3 className="text-xl font-bold text-gray-900 dark:text-gray-100 mb-3">{t('section5.sub3.title')}</h3>
              <p className="text-gray-700 dark:text-gray-300 leading-relaxed">{t('section5.sub3.content')}</p>
            </div>
          </section>

          {/* Section 6 */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-4">{t('section6.title')}</h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">{t('section6.intro')}</p>
            <ul className="space-y-3">
              {(t('section6.items', { returnObjects: true }) as string[]).map((item, index) => (
                <li key={index} className="text-gray-700 dark:text-gray-300 leading-relaxed">{item}</li>
              ))}
            </ul>
          </section>

          {/* Section 7 */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-4">{t('section7.title')}</h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">{t('section7.content')}</p>
          </section>

          {/* Section 8 */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-4">{t('section8.title')}</h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">{t('section8.intro')}</p>
            <ul className="space-y-3">
              {(t('section8.items', { returnObjects: true }) as string[]).map((item, index) => (
                <li key={index} className="text-gray-700 dark:text-gray-300 leading-relaxed">{item}</li>
              ))}
            </ul>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed mt-4 font-medium">{t('section8.note')}</p>
          </section>

          {/* Section 9 */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-4">{t('section9.title')}</h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">{t('section9.content')}</p>
          </section>

          {/* Section 10 */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-4">{t('section10.title')}</h2>
            
            <div className="mb-6">
              <h3 className="text-xl font-bold text-gray-900 dark:text-gray-100 mb-3">{t('section10.sub1.title')}</h3>
              <p className="text-gray-700 dark:text-gray-300 leading-relaxed">{t('section10.sub1.content')}</p>
            </div>

            <div>
              <h3 className="text-xl font-bold text-gray-900 dark:text-gray-100 mb-3">{t('section10.sub2.title')}</h3>
              <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">{t('section10.sub2.intro')}</p>
              <ul className="space-y-3">
                {(t('section10.sub2.items', { returnObjects: true }) as string[]).map((item, index) => (
                  <li key={index} className="text-gray-700 dark:text-gray-300 leading-relaxed">{item}</li>
                ))}
              </ul>
              <p className="text-gray-700 dark:text-gray-300 leading-relaxed mt-4 font-medium">{t('section10.sub2.note')}</p>
            </div>
          </section>

          {/* Section 11 */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-4">{t('section11.title')}</h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">{t('section11.intro')}</p>
            <ul className="space-y-3">
              {(t('section11.items', { returnObjects: true }) as string[]).map((item, index) => (
                <li key={index} className="text-gray-700 dark:text-gray-300 leading-relaxed">{item}</li>
              ))}
            </ul>
          </section>

          {/* Section 12 */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-4">{t('section12.title')}</h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">{t('section12.intro')}</p>
            <ul className="space-y-3">
              {(t('section12.items', { returnObjects: true }) as string[]).map((item, index) => (
                <li key={index} className="text-gray-700 dark:text-gray-300 leading-relaxed">{item}</li>
              ))}
            </ul>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed mt-4 font-medium">{t('section12.note')}</p>
          </section>

          {/* Section 13 */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-4">{t('section13.title')}</h2>
            
            <div className="mb-4">
              <h3 className="text-lg font-bold text-gray-900 dark:text-gray-100 mb-2">{t('section13.sub1.title')}</h3>
              <p className="text-gray-700 dark:text-gray-300 leading-relaxed">{t('section13.sub1.content')}</p>
            </div>

            <div className="mb-4">
              <h3 className="text-lg font-bold text-gray-900 dark:text-gray-100 mb-2">{t('section13.sub2.title')}</h3>
              <p className="text-gray-700 dark:text-gray-300 leading-relaxed">{t('section13.sub2.content')}</p>
            </div>

            <div>
              <h3 className="text-lg font-bold text-gray-900 dark:text-gray-100 mb-2">{t('section13.sub3.title')}</h3>
              <p className="text-gray-700 dark:text-gray-300 leading-relaxed">{t('section13.sub3.content')}</p>
            </div>
          </section>

          {/* Section 14 */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-4">{t('section14.title')}</h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">{t('section14.content')}</p>
          </section>

          {/* Section 15 */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-4">{t('section15.title')}</h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">{t('section15.content')}</p>
          </section>

          {/* Section 16 */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-4">{t('section16.title')}</h2>
            
            <div className="mb-4">
              <h3 className="text-lg font-bold text-gray-900 dark:text-gray-100 mb-2">{t('section16.sub1.title')}</h3>
              <p className="text-gray-700 dark:text-gray-300 leading-relaxed">{t('section16.sub1.content')}</p>
            </div>

            <div className="mb-4">
              <h3 className="text-lg font-bold text-gray-900 dark:text-gray-100 mb-2">{t('section16.sub2.title')}</h3>
              <p className="text-gray-700 dark:text-gray-300 leading-relaxed">{t('section16.sub2.content')}</p>
            </div>

            <div className="mb-4">
              <h3 className="text-lg font-bold text-gray-900 dark:text-gray-100 mb-2">{t('section16.sub3.title')}</h3>
              <p className="text-gray-700 dark:text-gray-300 leading-relaxed">{t('section16.sub3.content')}</p>
            </div>

            <div>
              <h3 className="text-lg font-bold text-gray-900 dark:text-gray-100 mb-2">{t('section16.sub4.title')}</h3>
              <p className="text-gray-700 dark:text-gray-300 leading-relaxed">{t('section16.sub4.content')}</p>
            </div>
          </section>

          {/* Section 17 */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-4">{t('section17.title')}</h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">{t('section17.intro')}</p>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-2" dangerouslySetInnerHTML={{ __html: t('section17.email') }} />
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-2" dangerouslySetInnerHTML={{ __html: t('section17.phone') }} />
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed" dangerouslySetInnerHTML={{ __html: t('section17.address') }} />
          </section>

          {/* Community Guidelines */}
          <section className="mb-12 bg-gray-50 dark:bg-gray-800 p-8 rounded-lg">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-4">{t('community.title')}</h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">{t('community.intro')}</p>
            <ul className="space-y-3">
              {(t('community.items', { returnObjects: true }) as string[]).map((item, index) => (
                <li key={index} className="text-gray-700 dark:text-gray-300 leading-relaxed" dangerouslySetInnerHTML={{ __html: item }} />
              ))}
            </ul>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
}
